<template>
  <ul ref="columnsList" v-if="isShowColumnsSelect">
    <li
      v-for="field in fields"
      :key="field.key"
    >
      <label v-bind:for="field.key">
          <input type="checkbox" v-model="field.visible" v-bind:id="field.key" @change="changeCustomize()">
          <span>{{ field.label }}</span>
      </label>
    </li>
  </ul>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'UiButtonCustomize',

  props: {
    isShowColumnsSelect: { type: Boolean, default: false },
    fields: { type: Array, default: () => [] }
  },
  methods: {
    ...mapActions({
      setCustomizeData: 'report/setCustomizeData'
    }),
    changeCustomize () {
      this.setCustomizeData(this.fields.filter(field => field.visible))
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    position: absolute;
    text-align: left;
    right: 0;
    background: #e9eef1;
    padding: 20px;
    top: 100%;
    border: 1px solid #acacac;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    z-index: 12;

    li {
      padding: 5px 0;

      label {
        cursor: pointer;
      }
    }
  }
</style>
